import React from "react";

const ArticleContent = ({ content }: { content: string }) => {
  if (!content) return null;

  return (
    <div
      className="article-content"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default ArticleContent;
